import { OktaAuth } from "@okta/okta-auth-js";

import config from "./okta-config.ts";

export const oktaAuth = new OktaAuth(config.oidc);
